import './InfoPanel.css';

function InfoPanel({item, id=0}) {
  const {title, content} = item;

  return (
    // <div id="product-panel" className="column is-one-quarter-widescreen is-5-tablet is-flex">
  <div className="column is-flex">
      <div className="box  is-flex is-flex-direction-column is-flex-grow-1 info-panel">
        <p className="has-text-primary has-text-centered title is-3">{title}</p>
        <p className="has-text-centered info-content">{content}</p>
      </div>
    </div>
  );
}

export default InfoPanel;